import AgGridWrapper from "../../su/AgGridWrapper.js";
import PageDetail from "../abstract/PageDetail.js";
import { SecurityAcl, AuthCheckAcl } from "../../Security.js";
import { ModalAlert, ModalConfirm } from "../../su/Modals.js";
export default class PageDMSUpload extends PageDetail {
    constructor() {
        super();
    }

    init($data) {
        super.init($data);
    }

}

